import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';
import validators from '../../../helpers/validators';
import { last, sortBy } from 'lodash';

import Textarea from '../../ui/textarea';
import Textfield from '../../ui/text-field';
import Modal from '../../ui/modal';

import validObj from '../../../helpers/validateObj';
import aaSave from '../../../helpers/afterActionSave';
import aaValidation from '../../../helpers/afterActionValidation';

class Ratings extends Component {
    handleSubmit = e => {
        const formObj = validObj(e);
        formObj.id = formObj.reportId;
        switch (this.props.userAction) {
            case 'save':
                formObj.deliverable = formObj.aadeliverable;
                formObj.recommend = formObj.aaRecommend;
                formObj.approverId = formObj.aaApproverId;
                this.props.updateAfterAction(formObj);
                break;
            case 'submit':
                const notValid = aaValidation(e);
                if (!notValid) {
                    formObj.recommend = formObj.aaRecommend;
                    formObj.deliverable = formObj.aadeliverable;
                    this.props.submitAfterAction(formObj);
                } else {
                    this.props.setEventErrorMessage(notValid);
                    if (e.aaawareness !== true && e.aabehavior !== true) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            false
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            false
                        );
                    } else if (
                        e.aaawareness === true ||
                        e.aabehavior === true
                    ) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            true
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            true
                        );
                    }
                }
                break;
            case 'approve':
                this.props.approveAfterAction(formObj);
                break;
            case 'request':
                this.props.requestInfoAfterAction(formObj);
                break;
            default:
                console.log(this.props.userAction);
        }
    };

    handleSubmitFailed = e => {
        if (this.props.userAction === 'save') {
            const values = aaSave(e);
            this.props.updateAfterAction(values);
        }
        if (this.props.userAction === 'request') {
            const values = aaSave(e);
            this.props.requestInfoAfterAction(values);
        }
    };

    render() {
        let saveSubmit = false;
        let approveReject = false;
        let userInfo = this.props.userInfo;
        const trustingUserId = userInfo.TrustingUser
            ? userInfo.TrustingUser.id
            : null;
        if (
            this.props.groupStatus.status === 'After Action Incomplete' ||
            this.props.groupStatus.status === 'After Action Pending'
        ) {
            if (
                this.props.afterActionUserID === this.props.userInfo.id ||
                this.props.afterActionUserID === trustingUserId
            ) {
                saveSubmit = true;
            }
        } else if (
            this.props.eventState.EventReport.status === 'Unapproved' &&
            this.props.groupStatus.status === 'After Action Review' &&
            this.props.tasks &&
            this.props.tasks.length > 0
        ) {
            const mostRecentTask = last(sortBy(this.props.tasks, 'id'));
            if (mostRecentTask.userId === this.props.userInfo.id) {
                if (mostRecentTask.action === 'Info') {
                    saveSubmit = true;
                } else {
                    approveReject = true;
                }
            }
        }

        let required = validators.empty();
        let textVal = validators.trimVal();

        return (
            <Form
                className="form"
                model="event"
                onSubmit={this.handleSubmit}
                onSubmitFailed={this.handleSubmitFailed}
            >
                <div className="tab__title">Ratings</div>

                <div className="first-col">
                    <Textarea
                        title="WAS THE TARGET MARKET IN ATTENDANCE (MALES AND FEMALES 17-24)?"
                        isRequired
                        rating
                        ratingModel="event.targetMarketRating"
                        model="event.targetMarketComments"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        ratingValidators={saveSubmit ? { required } : undefined}
                        ratingMessages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        maxLength={250}
                    />

                    <Textfield
                        isRequired
                        type="number"
                        title="Estimated Target Attendance"
                        model="event.estimatedTargetAttendance"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        ratingValidators={saveSubmit ? { required } : undefined}
                        ratingMessages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        onKeyPress
                        min="0"
                    />

                    <Textarea
                        title="WAS THIS A GOOD EVENT FOR ENLISTED OPPORTUNITIES (MALES AND FEMALES 17-24)?"
                        isRequired
                        rating
                        ratingModel="event.comingOfAgeRating"
                        model="event.comingOfAgeComments"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        ratingValidators={saveSubmit ? { required } : undefined}
                        ratingMessages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        maxLength={250}
                    />

                    <Textarea
                        title="WAS THIS A GOOD INFLUENCER EVENT?"
                        isRequired
                        rating
                        ratingModel="event.influentialRating"
                        model="event.influentialComments"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        ratingValidators={saveSubmit ? { required } : undefined}
                        ratingMessages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        maxLength={250}
                    />
                </div>

                <div className="second-col">
                    <Textarea
                        title="DID THIS EVENT PROVIDE LOCAL AWARENESS AND POSITIVE
                        COMMUNITY RELATIONS?"
                        isRequired
                        rating
                        ratingModel="event.communityRelationsRating"
                        model="event.communityRelationsComments"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        ratingValidators={saveSubmit ? { required } : undefined}
                        ratingMessages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        maxLength={250}
                    />

                    <Textarea
                        title="CONSIDERING THE SIZE OF THE EVENT, WAS IT A GOOD LEAD GENERATOR?"
                        isRequired
                        rating
                        ratingModel="event.leadGenerationRating"
                        model="event.leadGenerationComments"
                        validators={saveSubmit ? { textVal } : undefined}
                        messages={
                            saveSubmit
                                ? { textVal: textVal.message }
                                : undefined
                        }
                        ratingValidators={saveSubmit ? { required } : undefined}
                        ratingMessages={
                            saveSubmit
                                ? { required: required.message }
                                : undefined
                        }
                        disabled={!saveSubmit}
                        maxLength={250}
                    />
                </div>

                <Control.text
                    model="event.hidden"
                    type="hidden"
                    value="eventId"
                    disabled={!saveSubmit}
                />

                <div className="form__actions form__actions--global">
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--secondary btn--save"
                            type="submit"
                            model="event.userActionTaken"
                            value="save"
                            onClick={() => {
                                this.props.setEventUserAction('save');
                            }}
                        >
                            Save
                        </Control.button>
                    ) : null}
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--submit"
                            type="submit"
                            model="event.userActionTaken"
                            value="submit"
                            onClick={() => {
                                this.props.setEventUserAction('submit');
                            }}
                        >
                            Submit
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            value="approve"
                            onClick={() => {
                                this.props.setEventUserAction('approve');
                            }}
                        >
                            Approve
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Modal
                            title="Returned for Edit"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.requestModalActive}
                            toggleModal={this.props.toggleRequestModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'request'}
                        >
                            <div className="form__section-title">
                                Returned for Edit
                            </div>
                            <Textfield
                                model="event.aaRequestComments"
                                title="Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                </div>
            </Form>
        );
    }
}

export default Ratings;



// WEBPACK FOOTER //
// ./src/components/event/after-action/ratings.js